import React, { useEffect } from 'react';
import styled, { css } from 'styled-components';
import Text from '../../ui/Text';
import Button from '../../ui/Button';
import ArrowRightImg from './../../images/arrowRight.svg';
import { removeItemInArray } from '../../utils/Helper';
import { setMarks, setWildcard } from 'components/big9/actions';
import { connect } from 'react-redux';
import { detectMobile, formatDate } from '../../utils/UiHelper';
import { breakpoint } from '../../constants/breakpoints';
import { BetDefault } from './styled';
import {
    countriesIcons,
    internationalFlag,
} from '../../constants/big9IconsConfig';
import { BIG9_EVENT_STATUS } from 'constants/big9Config';
import { isTerminal } from '../../utils/UiHelper';

const ButtonOddsValues = {
    firstGroup: [
        {
            label: '1',
            mobLabel: '1',
            value: '1',
            width: '54px',
            mobWidth: '48px',
        },
        {
            label: 'X',
            mobLabel: 'X',
            value: 'X',
            width: '54px',
            mobWidth: '48px',
        },
        {
            label: '2',
            mobLabel: '2',
            value: '2',
            width: '54px',
            mobWidth: '48px',
        },
    ],
    secondGroup: [
        {
            label: 'Over 2.5',
            mobLabel: 'O 2.5',
            value: 'O',
            width: '80px',
            mobWidth: '60px',
        },
        {
            label: 'Under 2.5',
            mobLabel: 'U 2.5',
            value: 'U',
            width: '80px',
            mobWidth: '60px',
        },
    ],
    thirdGroup: [
        {
            label: 'Wildcard',
            mobLabel: 'W',
            value: '*',
            width: '70px',
            mobWidth: '48px',
        },
    ],
};

const ButtonResultsValues = {
    firstGroup: [
        {
            label: '1',
            mobLabel: '1',
            value: 'home',
            width: '70px',
            mobWidth: '56px',
        },
        {
            label: 'X',
            mobLabel: 'X',
            value: 'tie',
            width: '70px',
            mobWidth: '56px',
        },
        {
            label: '2',
            mobLabel: '2',
            value: 'away',
            width: '70px',
            mobWidth: '56px',
        },
    ],
    secondGroup: [
        {
            label: 'Over 2.5',
            mobLabel: 'O 2.5',
            value: 'over',
            width: '90px',
            mobWidth: '76px',
        },
        {
            label: 'Under 2.5',
            mobLabel: 'U 2.5',
            value: 'under',
            width: '90px',
            mobWidth: '76px',
        },
    ],
};

const Wrapper = styled.div`
    position: relative;
    height: auto;
    width: 100%;
    display: block;
    box-sizing: border-box;
    background: ${({ bg }) => bg || '#f5f7fc'};
    border-radius: 5px;
    padding: ${({ padding }) => padding || '22px 15px'};
    ${({ faded }) =>
        faded &&
        css`
            &:after {
                content: ' ';
                display: block;
                width: inherit;
                height: 100%;
                background: rgba(255, 255, 255, 0.5);
                position: absolute;
                left: 0;
                top: 0;
                padding: ${({ padding }) => padding || '22px 15px'};
                border-radius: 5px;
                box-sizing: border-box;
                z-index: 1;
            }
        `};

    &.isResults {
        padding: 15px 20px;
    }
    @media screen and ${breakpoint.S} {
        padding: ${({ padding }) => padding || '12px 9px'};
        &.isResults {
            padding: 15px 9px;
        }
    }
`;

const labelStyles = css`
    z-index: 3;
    position: absolute;
`;
const EventLabel = styled.div`
    ${labelStyles};
    right: 5px;
`;
const CanceledLabel = styled.div`
    ${labelStyles};
    background-color: #f4e4e4;
    border-radius: 5px;
    padding: 5px 15px;
    right: -5px;
    top: 5px;
`;

const DescriptionWrapper = styled.div`
    display: block;
    height: auto;
    width: 100%;
    box-sizing: border-box;
    cursor: pointer;
    padding-bottom: 15px;
`;

const TopWrapper = styled.div`
    position: relative;
    height: auto;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    box-sizing: border-box;
`;

const EventWrapper = styled.div`
    height: auto;
    width: 100%;
    display: block;
    box-sizing: border-box;
    margin: 0;
    padding: 0 40px 0 0;
    position: relative;
`;

const LeagueIcon = styled.img`
    height: 12px;
    width: 19px;
    display: block;
    box-sizing: border-box;
    margin: 0 5px 0 0;
    padding: 0;
`;

const ArrowRight = styled.img`
    position: absolute;
    right: -1px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
    @media screen and ${breakpoint.S} {
        right: 20px;
    }
`;

const OddsWrapper = styled.div`
    height: auto;
    width: 100%;
    padding: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    position: relative;
    box-sizing: border-box;
    &.line {
        background: none !important;
        &:before {
            content: '';
            position: absolute;
            left: 0;
            bottom: 15px;
            width: 100%;
            height: 1px;
            background: #edeff4;
        }
    }
`;

const ButtonsWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    &:first-child {
        width: 42%;
    }
    &:last-of-type {
        width: 70px;
        div {
            button.wildcardActive {
                height: 42px;
            }
            button {
                width: 100%;
            }
        }
    }
    @media screen and ${breakpoint.L} and (min-width: 600px) {
        width: calc(50% - 130px);
        &:first-child {
            width: 50%;
        }
        &:last-of-type {
            width: 100px;
        }
    }

    @media screen and (max-width: 600px) {
        div {
            button {
                width: 100%;
            }
        }
        &:first-child {
            button {
                width: 100%;
            }
        }
        &:last-of-type {
            div {
                button {
                    width: 100%;
                }
            }
        }
    }

    &.isResults {
        margin-right: 30px;
        &:last-of-type {
            width: auto;
            margin-right: 0;
        }
        @media screen and ${breakpoint.L} and (min-width: 600px) {
            &:first-child {
                width: calc(60% - 5px);
                margin-right: 0;
                div {
                    width: calc(100% / 3);
                }
            }
            &:last-of-type {
                width: calc(40% - 5px);
                div {
                    width: calc(50% - 5px);
                    button.wildcardActive {
                        height: 44px;
                    }
                }
            }
        }
        &.terminal {
            &:first-child {
                width: calc(60% - 50px);
                margin-right: 0;
                div {
                    width: calc(100% / 3 - 10px);
                }
            }
            &:last-of-type {
                width: calc(40% - 50px);
                div {
                    width: calc(50% - 10px);
                }
            }
        }
    }

    &.terminal {
        justify-content: space-between;
        &:first-child {
            width: 350px;
            & > div {
                width: calc(100% / 3 - 10px);
                margin: 0;
                button {
                    height: 50px;
                    width: 100%;
                }
            }
        }
        &:nth-child(2) {
            width: calc(100% - 570px);
            & > div {
                width: calc(100% / 2 - 10px);
                button {
                    height: 50px;
                    width: 100%;
                }
            }
        }
        &:last-of-type {
            width: 150px;
            margin-right: 0;
            & > div {
                width: 100%;
                button {
                    height: 50px;
                    width: 100%;
                    &.wildcardActive {
                        height: 52px;
                    }
                }
            }
        }
    }

    @media screen and ${breakpoint.S} {
        margin: 0 5px;
        &:first-child {
            margin-left: 0;
        }
        &:last-of-type {
            width: 48px;
            margin-right: 0;
        }
        &.isResults {
            margin-right: 0;
        }
    }
`;

const BetItemsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    box-sizing: border-box;
    &.item1 {
        width: calc(100% - 3px);
    }
    &.item2 {
        width: calc(100% / 2 - 5px);
    }
    &.item3 {
        width: 100%;
    }
    button {
        width: 100%;
    }

    /* @media screen and (max-width: 599px) and (min-width: 480px) {
        &.item1 {
            width: calc(100% / 3);
        }
        &.item2 {
            width: calc(100% / 2);
        }
        &.item3 {
            width: 100px;
        }
        button {
            width: 100%;
        }
    }*/
    &:first-child {
        margin-left: 0;
    }
    &:last-of-type {
        margin-right: 0;
    }
`;
const ButtonItemWrapper = styled.div`
    display: block;
    box-sizing: border-box;
    height: 40px;
    width: ${({ width }) => (width ? width : '0 3px')};
    margin: ${({ margin }) => (margin ? margin : '0 3px')};
    &.results {
        height: auto;
    }
    &.terminal {
        height: 50px;
        width: 100%;
    }
    &:first-child {
        margin-left: 0;
    }
    &:last-of-type {
        margin-right: 0;
    }
    @media screen and ${breakpoint.L} and (min-width: 490px) {
        width: calc(100% - 10px);
    }
`;

const HiddenText = styled.div`
    height: auto;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`;

const MatchResult = styled.div`
    display: block;
    color: #333;
    font-size: 16px;
    line-height: 16px;
    font-weight: 700;
    position: absolute;
    right: 5px;
    top: 3px;
    z-index: 1;
    @media screen and ${breakpoint.S} {
        right: 5px;
    }
`;

const Big9Card = ({
    competition,
    startTime,
    eventName,
    number,
    setMarks,
    outcomes,
    setWildcard,
    wildcard,
    isResults,
    matchResult = '',
    results,
    isVisiblePercents,
    isVisibleOdds = false,
    oddsPercents,
    oddsAmount,
    country,
    externalId,
    chooseExternalId = () => {},
    status = '',
    matchTime = null,
}) => {
    useEffect(
        () => {
            if (status === BIG9_EVENT_STATUS.canceled && !isResults) {
                setMarks({
                    [number]: {
                        marks: ['X', 'U'],
                        eventName: eventName,
                        status,
                    },
                });
            }
        },
        [setMarks]
    );

    const getOddsButtons = () => {
        return (
            <>
                {Object.keys(ButtonOddsValues).map((objectKey, index) => {
                    return (
                        <ButtonsWrapper
                            key={index + 'q'}
                            className={isTerminal() ? 'terminal' : null}
                        >
                            {ButtonOddsValues[objectKey].map(
                                (item, indexInside) => {
                                    let buttonWidth = detectMobile()
                                        ? item.mobWidth
                                        : item.width;

                                    let label = detectMobile()
                                        ? item.mobLabel
                                        : item.label;
                                    return (
                                        <BetItemsWrapper
                                            key={indexInside + 'res'}
                                            className={`item${index + 1}`}
                                        >
                                            <ButtonItemWrapper
                                                className={
                                                    isTerminal()
                                                        ? 'terminal'
                                                        : null
                                                }
                                                width={buttonWidth}
                                            >
                                                <Button
                                                    fontSize={
                                                        isTerminal()
                                                            ? '14px'
                                                            : '12px'
                                                    }
                                                    oddsYellow
                                                    width={buttonWidth}
                                                    margin="0"
                                                    padding="13px 14px"
                                                    onClick={() =>
                                                        updateSelection(
                                                            item.value
                                                        )
                                                    }
                                                    active={
                                                        status !==
                                                            BIG9_EVENT_STATUS.canceled &&
                                                        outcomes[
                                                            number
                                                        ]?.marks.includes(
                                                            item.value
                                                        )
                                                    }
                                                    className={
                                                        item.value === '*' &&
                                                        outcomes[
                                                            number
                                                        ]?.marks.includes('*')
                                                            ? 'wildcardActive'
                                                            : 'wildcard'
                                                    }
                                                    height={
                                                        isTerminal() &&
                                                        item.value === '*' &&
                                                        outcomes[
                                                            number
                                                        ]?.marks.includes('*')
                                                            ? '50px'
                                                            : '40px'
                                                    }
                                                >
                                                    {item.value === '*' &&
                                                    outcomes[
                                                        number
                                                    ]?.marks.includes('*') ? (
                                                        <HiddenText>
                                                            <Text
                                                                width="auto"
                                                                size={
                                                                    isTerminal()
                                                                        ? '14'
                                                                        : '12'
                                                                }
                                                                bold
                                                                color="#333"
                                                            >
                                                                Wildcard - alle
                                                                udfald
                                                            </Text>
                                                            <Text
                                                                width="auto"
                                                                size={
                                                                    isTerminal()
                                                                        ? '14'
                                                                        : '12'
                                                                }
                                                                bold
                                                                color="#333"
                                                                align="right"
                                                            >
                                                                Fjern
                                                            </Text>
                                                        </HiddenText>
                                                    ) : (
                                                        label
                                                    )}
                                                </Button>
                                            </ButtonItemWrapper>

                                            {isVisiblePercents ? (
                                                <Text
                                                    margin="5px 0 0"
                                                    padding="0"
                                                    size={
                                                        isTerminal()
                                                            ? '14'
                                                            : '12'
                                                    }
                                                >
                                                    {oddsPercents[item.value] >
                                                    0
                                                        ? `${
                                                              oddsPercents[
                                                                  item.value
                                                              ]
                                                          }%`
                                                        : '0%'}
                                                </Text>
                                            ) : null}

                                            {isVisibleOdds ? (
                                                <Text
                                                    margin="6px 0 0"
                                                    padding="0"
                                                    size={
                                                        isTerminal()
                                                            ? '14'
                                                            : '12'
                                                    }
                                                >
                                                    {oddsAmount[item.value]}
                                                </Text>
                                            ) : null}
                                        </BetItemsWrapper>
                                    );
                                }
                            )}
                        </ButtonsWrapper>
                    );
                })}
            </>
        );
    };

    const getResultsButtons = () => {
        return (
            <>
                {Object.keys(ButtonResultsValues).map((objectKey, index) => {
                    return (
                        <ButtonsWrapper
                            key={index + 'asd'}
                            className={
                                isTerminal()
                                    ? 'terminal isResults'
                                    : 'isResults'
                            }
                        >
                            {ButtonResultsValues[objectKey].map(
                                (item, indexInside) => {
                                    let buttonWidth = detectMobile()
                                        ? item.mobWidth
                                        : item.width;

                                    let label = detectMobile()
                                        ? item.mobLabel
                                        : item.label;

                                    let resultsArr = results
                                        .replace(/ /g, '')
                                        .split(',');

                                    let match = false;

                                    if (resultsArr.includes(item.value)) {
                                        match =
                                            resultsArr[
                                                resultsArr.indexOf(item.value)
                                            ] === item.value;
                                    }

                                    return (
                                        <ButtonItemWrapper
                                            className={isResults && 'results'}
                                            key={indexInside + 'y'}
                                        >
                                            <BetDefault
                                                width={buttonWidth}
                                                key={indexInside + 'bet25'}
                                                fontSize={
                                                    isTerminal()
                                                        ? '14px'
                                                        : '12px'
                                                }
                                                lineHeight={
                                                    isTerminal()
                                                        ? '14px'
                                                        : '12px'
                                                }
                                                className={
                                                    isTerminal()
                                                        ? match
                                                            ? 'terminal activeResult'
                                                            : 'terminal results'
                                                        : match
                                                            ? 'activeResult'
                                                            : 'results'
                                                }
                                            >
                                                {label}
                                            </BetDefault>

                                            {isVisiblePercents ? (
                                                <Text
                                                    margin="5px 0 0"
                                                    padding="0"
                                                    size={
                                                        isTerminal()
                                                            ? '14'
                                                            : '12'
                                                    }
                                                    align={'center'}
                                                >
                                                    {oddsPercents[item.value] >
                                                    0
                                                        ? `${
                                                              oddsPercents[
                                                                  item.value
                                                              ]
                                                          }%`
                                                        : '0%'}
                                                </Text>
                                            ) : null}
                                        </ButtonItemWrapper>
                                    );
                                }
                            )}
                        </ButtonsWrapper>
                    );
                })}
            </>
        );
    };

    const updateSelection = (value) => {
        const chosenMarks = outcomes[number]?.marks || [];
        let resultedValues;

        if (wildcard !== null && value === '*') {
            let removedPrevWildcard = removeItemInArray(
                outcomes[wildcard]?.marks || [],
                value
            );

            setMarks({
                [wildcard]: {
                    marks: removedPrevWildcard,
                },
            });
        }

        if (chosenMarks.includes(value)) {
            resultedValues = removeItemInArray(chosenMarks, value);
        } else {
            resultedValues = [...chosenMarks, ...value];
        }

        if (value === '*') {
            setWildcard(wildcard === number ? null : number);
        }
        setMarks({
            [number]: {
                marks: resultedValues,
                eventName: eventName,
            },
        });
    };

    const getCountryIcon = (country) => {
        if (country) {
            return (
                <LeagueIcon
                    src={
                        countriesIcons.hasOwnProperty(country.toLowerCase())
                            ? countriesIcons[country.toLowerCase()]
                            : internationalFlag
                    }
                    margin="0 5px 0 0"
                />
            );
        }
    };

    const getEventLabel = (status, matchTime) => {
        switch (status) {
            case BIG9_EVENT_STATUS.canceled:
                return (
                    <CanceledLabel>
                        <Text
                            condensed
                            size="x07"
                            padding="0"
                            color={'#111111'}
                            bold
                        >
                            Aflyst kamp
                        </Text>
                    </CanceledLabel>
                );
            case BIG9_EVENT_STATUS.decided:
                return (
                    <EventLabel>
                        <Text
                            condensed
                            size="x07"
                            padding="0"
                            color={'#333'}
                            bold
                        >
                            Afsluttet
                        </Text>
                    </EventLabel>
                );
            case BIG9_EVENT_STATUS.ongoing:
                return matchTime > 0 || matchTime === 'HT' ? (
                    <EventLabel>
                        <Text
                            condensed
                            size="x07"
                            padding="0"
                            color={'#F60E0F'}
                            bold
                        >
                            {matchTime === 'HT' ? 'HT' : `${matchTime}'`}
                        </Text>
                    </EventLabel>
                ) : null;
            case BIG9_EVENT_STATUS.upcoming:
            default:
                return null;
        }
    };

    const getDate = (date) => {
        if (typeof date === 'number') {
            return formatDate(date, 'HH:mm');
        } else {
            return date;
        }
    };

    return (
        <Wrapper
            bg={number % 2 ? 'transparent' : null}
            className={isResults ? '15px 20px' : null}
            faded={
                status === BIG9_EVENT_STATUS.canceled ||
                (isResults && status === BIG9_EVENT_STATUS.upcoming)
            }
        >
            <DescriptionWrapper onClick={() => chooseExternalId(externalId)}>
                <TopWrapper>
                    {competition === null && startTime === null ? (
                        <Text
                            margin="0"
                            size={isTerminal() ? '16' : '12'}
                            padding="0"
                        >
                            -
                        </Text>
                    ) : (
                        <>
                            {getCountryIcon(country)}
                            <Text
                                margin="0"
                                size={isTerminal() ? '16' : '12'}
                                padding="0"
                            >
                                {`${competition} - ${getDate(startTime)}`}
                            </Text>
                        </>
                    )}
                    {getEventLabel(status, matchTime)}
                </TopWrapper>

                <EventWrapper>
                    <Text
                        margin="5px 0 0"
                        size={isTerminal() ? '20' : '16'}
                        bold
                        color="#333"
                        padding="0"
                    >
                        {`${number}. ${eventName}`}
                    </Text>
                    {!isResults && status !== BIG9_EVENT_STATUS.canceled ? (
                        <ArrowRight src={ArrowRightImg} />
                    ) : null}
                    {status !== BIG9_EVENT_STATUS.canceled && (
                        <MatchResult>
                            {matchResult.length > 0
                                ? matchResult.replace('-', ':')
                                : ''}
                        </MatchResult>
                    )}
                </EventWrapper>
            </DescriptionWrapper>
            <OddsWrapper
                className={isVisiblePercents && isVisibleOdds ? 'line' : null}
            >
                {isResults ? getResultsButtons() : getOddsButtons()}
            </OddsWrapper>
        </Wrapper>
    );
};

const mapStateToProps = (state) => {
    return {
        outcomes: state.big9.couponData.outcomes,
        wildcard: state.big9.couponData.wildcard,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setMarks: (outcomes) => {
            dispatch(setMarks(outcomes));
        },
        setWildcard: (key) => {
            dispatch(setWildcard(key));
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Big9Card);
